import type { ReactNode } from 'react';

/**
 * A teaching empty state (user-guidance layer). Instead of a bare «داده‌ای نیست» line, it names what
 * is missing, explains the next step, and offers the action that fills it — so an empty surface leads
 * the user forward instead of dead-ending. Compose it: pass an emoji `icon`, a short `title`, a `hint`
 * sentence, and optionally an `action` (usually a Button that starts the flow, or a link to it).
 */
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: string;
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      {icon ? (
        <div className="empty-ico" aria-hidden>
          {icon}
        </div>
      ) : null}
      <div className="empty-title">{title}</div>
      {hint ? <p className="empty-hint">{hint}</p> : null}
      {action ? <div className="empty-action">{action}</div> : null}
    </div>
  );
}
